module.exports = __webpack_public_path__ + "static/media/PilbaraNews-devicecomp-min.c4c75416.webp";